import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import OverviewRegisteredOrders from './components/biReports/OverviewRegisteredOrders';
import OverviewRegisteredSales from './components/biReports/OverviewRegisteredSales';
import OverviewRegisteredOrderShare from './components/biReports/OverviewRegisteredOrderShare';
import OverviewRegisteredSalesShare from './components/biReports/OverviewRegisteredSalesShare';

import OverviewRegisteredAOV from './components/biReports/OverviewRegisteredAOV';
import OverviewAnonymousAOV from './components/biReports/OverviewAnonymousAOV';
import OverviewAnonymousOrders from './components/biReports/OverviewAnonymousOrders';
import OverviewAnonymousSales from './components/biReports/OverviewAnonymousSales';

import ClientsActivityEvolution from './components/biReports/ClientsActivityEvolution';
import ClientsActivityComparison from './components/biReports/ClientsActivityComparison';
import ClientsActivityByLocation from './components/biReports/ClientsActivityByLocation';

import Client from './components/Client';

class RapClientsActivity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      edit: false,
      periodMode: "last_30d",
    };
  }

  componentDidMount() {
    if (this.props.onReady) {
      this.props.onReady();
    }
  }

  componentWillUnmount() {
  }

  handlePeriodChange = (event, newPeriodMode) => {
    if (!newPeriodMode) return;

    this.setState({
      periodMode: newPeriodMode,
    });
  };

  render() {
    const { periodMode } = this.state;

    const fullWidthChildSx = {
      width: '100%',
      minWidth: 0,
      '& > *': {
        width: '100% !important',
        maxWidth: '100% !important',
        mx: '0 !important',
        boxSizing: 'border-box',
      },
    };

    const reportBoxSx = {
      width: '100%',
      minWidth: 0,
      height: {
        xs: 380,
        sm: 420,
        md: 460,
        lg: 500,
      },
      minHeight: 0,
      overflow: 'hidden',
      borderRadius: {
        xs: '14px',
        sm: '16px',
      },
      boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
      border: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
      boxSizing: 'border-box',

      '& > *': {
        width: '100% !important',
        maxWidth: '100% !important',
        height: '100% !important',
        maxHeight: '100% !important',
        minHeight: '0 !important',
        mx: '0 !important',
        boxSizing: 'border-box',
      },

      '& .MuiCard-root': {
        width: '100% !important',
        height: '100% !important',
        maxHeight: '100% !important',
        minHeight: '0 !important',
        borderRadius: {
          xs: '14px',
          sm: '16px',
        },
        boxShadow: 'none',
        border: 'none',
        overflow: 'hidden',
        boxSizing: 'border-box',
      },

      '& .MuiCardContent-root': {
        height: '100%',
        maxHeight: '100%',
        minHeight: 0,
        boxSizing: 'border-box',
      },
    };

    return (
      <Box
        component="main"
        sx={{
          // bgcolor: '#f4f7fb',
          minHeight: '100vh',
          flexGrow: 1,
          width: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          maxWidth: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          ml: {
            xs: 'calc(50% - 50vw + 4px)',
            sm: 0,
          },
          overflowX: 'hidden',
          pt: { xs: 0.75, sm: 1.5, md: 3 },
          pb: { xs: 1, sm: 2, md: 3 },
          px: { xs: 0.5, sm: 1, md: 2 },
          boxSizing: 'border-box',

          '& .MuiGrid-item': {
            minWidth: 0,
          },
          '& .MuiCard-root': {
            maxWidth: '100%',
            boxSizing: 'border-box',
          },
        }}
      >
        <Grid
          container
          spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
          sx={{
            width: '100%',
            maxWidth: '100%',
            m: 0,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              p: '0 !important',
              mb: { xs: 0.75, md: 1.25 },
            }}
          >
            <Stack
              direction="row"
              spacing={{ xs: 1, sm: 1.5 }}
              alignItems="center"
              justifyContent="space-between"
              sx={{
                width: '100%',
                px: { xs: 1.25, sm: 1.75, md: 2 },
                py: { xs: 1.25, sm: 1.5, md: 1.75 },
                bgcolor: '#ffffff',
                borderRadius: { xs: '14px', sm: '16px' },
                border: '1px solid rgba(15, 23, 42, 0.06)',
                boxShadow: '0 4px 14px rgba(15, 23, 42, 0.06)',
                boxSizing: 'border-box',
              }}
            >
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: '1rem', sm: '1.15rem', md: '1.35rem' },
                    lineHeight: 1.2,
                    color: '#020617',
                  }}
                >
                  Clients Activity
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    mt: 0.25,
                    color: '#475569',
                    fontSize: { xs: '0.72rem', sm: '0.82rem' },
                  }}
                >
                  Registered vs anonymous sales activity
                </Typography>
              </Box>

              <ToggleButtonGroup
                exclusive
                size="small"
                value={periodMode}
                onChange={this.handlePeriodChange}
                sx={{
                  alignSelf: 'center',
                  flexShrink: 0,
                  bgcolor: '#fff',
                  borderRadius: '12px',
                  boxShadow: '0 2px 8px rgba(15, 23, 42, 0.06)',
                  '& .MuiToggleButtonGroup-grouped': {
                    borderColor: 'rgba(15, 23, 42, 0.08)',
                  },
                  '& .MuiToggleButton-root': {
                    minWidth: { xs: 34, sm: 42 },
                    px: { xs: 0.75, sm: 1.25 },
                    py: { xs: 0.35, sm: 0.45 },
                    fontSize: { xs: '0.66rem', sm: '0.75rem' },
                    fontWeight: 700,
                    textTransform: 'none',
                    color: '#334155',
                    borderColor: 'rgba(15, 23, 42, 0.08)',
                    '&.Mui-selected': {
                      bgcolor: '#0f172a',
                      color: '#fff',
                      '&:hover': {
                        bgcolor: '#111827',
                      },
                    },
                  },
                }}
              >
                <ToggleButton value="last_7d">7d</ToggleButton>
                <ToggleButton value="last_30d">30d</ToggleButton>
                <ToggleButton value="last_90d">90d</ToggleButton>
              </ToggleButtonGroup>
            </Stack>
          </Grid>

          <Grid item xs={12} sx={{ p: '0 !important' }}>
            <Grid
              container
              spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
              sx={{
                width: '100%',
                m: 0,
              }}
            >
              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewRegisteredOrders periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewRegisteredSales periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewRegisteredOrderShare periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewRegisteredSalesShare periodMode={periodMode} />
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ p: '0 !important', mt: { xs: 0.75, md: 1.5 } }}>
            <Grid
              container
              spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
              sx={{
                width: '100%',
                m: 0,
              }}
            >
              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewRegisteredAOV periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewAnonymousAOV periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewAnonymousOrders periodMode={periodMode} />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewAnonymousSales periodMode={periodMode} />
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={8}
            sx={{
              pl: { xs: '0 !important', md: undefined },
              mt: { xs: 0.75, md: 1.5 },
            }}
          >
            <Box sx={reportBoxSx}>
              <ClientsActivityEvolution periodMode={periodMode} />
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={4}
            sx={{
              mt: { xs: 0.75, md: 1.5 },
            }}
          >
            <Box sx={reportBoxSx}>
              <ClientsActivityComparison periodMode={periodMode} />
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            sx={{
              pl: { xs: '0 !important', md: undefined },
            }}
          >
            <Box
              sx={{
                ...reportBoxSx,
                height: {
                  xs: 440,
                  sm: 460,
                  md: 500,
                  lg: 540,
                },
              }}
            >
              <ClientsActivityByLocation periodMode={periodMode} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default RapClientsActivity;